import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "./CartSubscriptionForm";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import {cancelAddSubscriptionToCart} from "../../actions/AccountApiActions";
import {fromJS, Map, List} from "immutable";
import {validateGreaterThan} from "../../lib/Validators";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

function validateForm(values) {
  let errors = Map();
  errors = validateGreaterThan(errors, values, "frequencyWeeks", 0);
  // At least 1 product needs to have quantity above 0.
  // Products with 0 will be removed before sending.
  if (values.get("products", List()).every((value, key) => value.get("quantity") === 0)) {
    errors = errors.set("products", Map({_error: "At least one product must have a quantity."}));
  }
  return errors.toJS();
}


class AddSubscriptionToCartFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    let products = 
      // Filter only products with a quantity.
      values.get("products").filter(x => x.get("quantity"))
            .map(x => {
                // Only send productSku and quantity
                return Map({
                  productSku: x.get("productSku"),
                  quantity: x.get("quantity")
                })
              });

    let updatedValues = 
      values.set("accountId", this.props.accountId)
            .set("products", products);

    return this.props.addSubscriptionToCart(updatedValues.toJS())
      .then((response) => {
        if (response.data.addSubscriptionToCart.errors.length <= 0) {
          this.props.cancelAddSubscriptionToCart();
        } else {
          let errors = createValidationErrors(response.data.addSubscriptionToCart.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleRemove() {
    return this.props.removeSubscriptionFromCart({account_id: this.props.accountId})
      .then((response) => {
        if (response.data.removeSubscriptionFromCart.errors.length <= 0) {
          this.props.cancelAddSubscriptionToCart();
        } else {
          let errors = createValidationErrors(response.data.removeSubscriptionFromCart.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });       
  }

  handleCancel() {
    this.props.cancelAddSubscriptionToCart();
  }

  render() {
    let {data} = this.props;
    if (data.loading) return <Loading />
    if (data.error) return <GraphQLErrors error={data.error} />

    const subscribeable = fromJS(data.shopSubscriptionProductsForAccount);
    const info = fromJS(data.cart);
    // Map items.
    let mapped = 
      info.get("items")
      // Remove those that are not subscribtion products first.
      .filter((x) => x.get("subscription") === true)
      .reduce((acc, x) => {
        return acc.set(x.get("productSku"), x.get("quantity")) 
      }, Map());
    // Go through each subscribeable and add either quantity or 0.
    let products = subscribeable.map(x => {
      return x.set("quantity", mapped.get(x.get("productSku"), 0));
    })

    let frequencyWeeks = 4;
    if (info.get("subscription") === true) {
      frequencyWeeks = info.get("subscriptionFrequencyWeeks", 4);
    }

    let initialValues = Map({
      name: "",
      frequencyWeeks: frequencyWeeks,
      products: products
    });

    return (
      <Form
        initialValues={initialValues}
        errors={this.state.errors}
        frequency={fromJS(data.subscriptionFrequencyOptions)}
        validate={validateForm}
        showRemove={info.get("subscription") === true}
        onRemove={this.handleRemove.bind(this)}
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }

}


const ADD_SUBSCRIPTION_TO_CART = gql`
  mutation addSubscriptionToCart($data: AddSubscriptionToCartInput!) {
    addSubscriptionToCart(input: $data) {
      errors { key message }
    }
  }
`;

const REMOVE_SUBSCRIPTION_FROM_CART = gql`
  mutation RemoveSubscriptionFromCart($data: AccountInput!) {
    removeSubscriptionFromCart(input: $data) {
      errors { key message }
    }
  }
`;

const LIST_SHOP_PRODUCTS_FOR_ACCOUNT = gql`
  query shopSubscriptionProductsForAccount($accountId: ID!) {
    shopSubscriptionProductsForAccount(accountId: $accountId) {
      shopId
      productSku
      productTitle
    }
    cart(accountId:$accountId) {
      shopId
      subscriptionFrequencyWeeks
      subscription
      items {
        productSku,
        quantity,
        subscription
      }
    }        
    subscriptionFrequencyOptions {
      title
      value
    }
  }
`;

const withProductQuery = compose(
  graphql(LIST_SHOP_PRODUCTS_FOR_ACCOUNT, {
    options: (props) => ({
      fetchPolicy: "network-only",
      variables: {
        accountId: props.accountId
      }
    })
  }),
  graphql(ADD_SUBSCRIPTION_TO_CART, {
    props: ({ mutate }) => ({
      addSubscriptionToCart: (data) => mutate({
        variables: { data: data }
      })
    })
  }),
  graphql(REMOVE_SUBSCRIPTION_FROM_CART, {
    props: ({ mutate }) => ({
      removeSubscriptionFromCart: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

const AddSubscriptionToCartFormContainerWithData = withProductQuery(AddSubscriptionToCartFormContainer);

export default connect(null, {cancelAddSubscriptionToCart})(AddSubscriptionToCartFormContainerWithData);